import { AnyAction, combineReducers, Reducer } from 'redux';

import autoSourcingRule, { type AutoSourcingRuleMap } from './autoSourcingRule/reducer';
import auth from './auth/reducer';
import budget from './budget/reducer';
import budgetAllocation, { BudgetAllocationMap } from './budgetAllocation/reducer';
import donationMatchingRule, { DonationMatchingRuleState } from './donationMatchingRule/reducer';
import donationCreditRule, { DonationCreditRuleState } from './donationCreditRule/reducer';
import campaign, { CampaignState } from './campaign/reducer';
import cause, { CauseState } from './cause/reducer';
import skill from './skill/reducer';
import picture from './picture/reducer';
import deed, { DeedState } from './deed/reducer';
import user, { UserState } from './user/reducer';
import location, { LocationState } from './location/reducer';
import organizers from './organizer/reducer';
import role from './role/reducer';
import volunteers, { VolunteerState } from './volunteers/reducer';
import donation, { DonationState } from './donation/reducer';
import stats from './stats/reducer';
import partners from './partners/reducer';
import form from './form/reducer';
import volunteerTime, { type VolunteerTimeState } from './volunteerTime/reducer';
import walletTransaction, { type WalletTransactionState } from './walletTransaction/reducer';
import volunteerTimeOff from './volunteerTimeOff/reducer';
import organization from './organization/reducer';
import donationSchedule, { type DonationScheduleState } from './donationSchedule/reducer';

export type EntityState = {
  auth: never;
  budget: any;
  budgetAllocation: BudgetAllocationMap;
  donationMatchingRule: DonationMatchingRuleState;
  donationCreditRule: DonationCreditRuleState;
  campaign: CampaignState;
  cause: CauseState;
  skill: any;
  picture: any;
  deed: DeedState;
  user: UserState;
  location: LocationState;
  volunteers: VolunteerState;
  donation: DonationState;
  stats: any;
  partners: any;
  form: any;
  organizers: any;
  role: any;
  volunteerTime: VolunteerTimeState;
  walletTransaction: WalletTransactionState;
  autoSourcingRule: AutoSourcingRuleMap;
  volunteerTimeOff: any;
  organization: any;
  donationSchedule: DonationScheduleState;
};

const entitiesReducer: Reducer<EntityState, AnyAction> = combineReducers({
  auth,
  budget,
  budgetAllocation,
  donationMatchingRule,
  donationCreditRule,
  campaign,
  cause,
  skill,
  picture,
  deed,
  user,
  location,
  volunteers,
  donation,
  stats,
  partners,
  form,
  organizers,
  role,
  volunteerTime,
  walletTransaction,
  autoSourcingRule,
  volunteerTimeOff,
  organization,
  donationSchedule,
});

export default entitiesReducer;
